module.exports = __webpack_public_path__ + "img/328.c8cd3b9d.png";